import { Button, List, TextField, Typography } from '@material-ui/core';
import React, { PureComponent } from 'react';
import QueryItem from './QueryItem';

class QuerySidebar extends PureComponent {
    render() {
        const content = this.props.user ? (
            <div className="sidebar-content">
                <div className="sidebar-header">
                    <TextField fullWidth placeholder="Filter" type="search" value={this.props.queryFilter} onChange={this._handleChangeFilter} />
                </div>
                <List dense className="saved-query-list">
                    {this.props.savedQueries.map(q => <QueryItem key={q.name} query={q} onClickQuery={this.props.onClickQuery} onDeleteQuery={this.props.onDeleteQuery} />)}
                </List>
            </div>
        ) : (
            <div className="sidebar-content">
                <div className="overlay">
                    <Typography color="textSecondary" variant="subheading" gutterBottom>Sign-in to access saved queries</Typography>
                    <Button variant="raised" color="primary" onClick={this.props.onLogin}>Sign-in</Button>
                </div>
            </div>
        );
        return (
            <div className="sidebar">
                {content}
            </div>
        );
    }

    _handleChangeFilter = (event) => {
        this.props.onChangeFilter(event.target.value);
    };
}

export default QuerySidebar;



// WEBPACK FOOTER //
// ./src/components/QuerySidebar.js